export default __webpack_public_path__ + "static/Controls-830f020b75fb9ffa0ab2308e23681d9b.png";